/* ControlJnibAdapterAddOn.js */

"use strict";
const _ = require("lodash");
const mix = require("../util/mix");
const BaseJnibAdapter = require("../BaseJnibAdapter");
const NibApiMixin = require("../control/ControlNibApiMixin");

const UserSessionMixin = require("../BaseUserSessionMixin");

const WizardUIMixin = require("../BaseWizardUIMixin");
const CommonUIMixin = require("../BaseCommonUIMixin");

const platform_sdk = require("@gluenetworks/platform-sdk-remote");
const ConnectionHandlerFactory = platform_sdk.connectionFactories.ConnectionHandlerFactory;
const AbstractServiceFactory = platform_sdk.serviceFactories.AbstractServiceFactory;

class ControlJnibAdapterAddOn extends mix(BaseJnibAdapter).with(
    NibApiMixin,
    UserSessionMixin,
    WizardUIMixin,
    CommonUIMixin
) {
    constructor(labUserSesion, steveIO, logger) {
        super(labUserSesion, logger);
        //This is set during the initialization phase and is expected to be in place by all mixins.
        this._nibApiService = null;
        this._fileFactory = steveIO.fileFactory;
    }
    get nibApiService() {
        return this.getNibApiService();
    }
    getNibApiService() {
        return this._nibApiService;
    }

    getFileFactory() {
        return this._fileFactory;
    }

    get fileFactory() {
        return this.getFileFactory();
    }

    /*******************************************/
    /* START STEVE ADD-ON METHODS              */
    /*******************************************/
    initialize(/*steve, addOnOptions*/) {
        //jshint ignore:line
        return (
            Promise.resolve()
                .then(() => {
                    //This will create a AbstractService and wire it up to the singleton ws ConnectionHandler
                    this._serviceFactory = AbstractServiceFactory.getInstance("ws", {
                        connectionHandler: ConnectionHandlerFactory.getInstance("socket"),
                    });
                })
                .then(() => {
                    return new Promise((resolve) => {
                        //MonkeyPatch the NIB adapter and attempt to keep "this" straight
                        for (let key in this._nibAdapter) {
                            //If this key is being overwritten
                            if (key in this) {
                                if (_.isFunction(this._nibAdapter[key])) {
                                    this._nibAdapter[key] = this[key].bind(this);
                                } else {
                                    this._nibAdapter[key] = this[key];
                                }
                            }
                        }
                        this._nibAdapter.initialized = true;
                        //Note: At this point the webJnibEngine is waiting for the next turn of the event loop
                        //to initialize itself, so we will do the same here so we make sure things are properly setup
                        setTimeout(() => {
                            resolve();
                        }, 0);
                    });
                })
                //load the nibApiService
                .then(() => {
                    return Promise.resolve()
                        .then(() => {
                            return this._serviceFactory.getServiceInstance("NibApi");
                        })
                        .then((nibApiService) => {
                            this._nibApiService = nibApiService;
                        });
                })

                //load the hubbyService
                .then(() => {
                    return Promise.resolve()
                        .then(() => {
                            return this._serviceFactory.getServiceInstance("Hubby");
                        })
                        .then((hubbyService) => {
                            this._hubbyService = hubbyService;
                        });
                })
        );
    }
    startUp(/*steve, addOnOptions*/) {
        //jshint ignore:line
    }
    /*******************************************/
    /* END STEVE ADD-ON METHODS                */
    /*******************************************/

    /********************************************/
    /* PUBLIC ACCESS METHODS                    */
    /********************************************/

    getHubbyService() {
        return this._hubbyService;
    }

    get hubbyService() {
        return this.getHubbyService();
    }
}
module.exports = ControlJnibAdapterAddOn;
module.exports.$inject = ["$teve.userSession", "$teve.io", "$teve.logger"];
